/**
 * Get the block attribute options
 *
 * @param {Object} state          CSS Library State
 * @param {string} blockName      Name of the block
 * @param {string} blockAttribute Block attribute name
 * @return {Array}                Array of objects of the block attribute options
 */
export function getBlockAttributeOptions(state, blockName, blockAttribute) {
  const { defaultCssLibrary, cssLibrary } = state;
  return cssLibrary[defaultCssLibrary][blockName][blockAttribute].options;
}

/**
 *
 * @param {Object} state CSS Library State
 * @return {string}      Default CSS library name
 */
export function getDefaultCssLibrary(state) {
  const { defaultCssLibrary } = state;
  return defaultCssLibrary;
}
